import { Router } from '@angular/router';
import { Component, TemplateRef, ViewChild, ChangeDetectorRef, Injectable } from '@angular/core';
import { MatDialog,  MatDialogConfig } from '@angular/material/dialog';
import {  MatSnackBar} from '@angular/material/snack-bar';
import { FormGroup, FormBuilder, Validators, FormControl, Form } from '@angular/forms';
import { UserService } from 'src/app/services/user.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { formatNumber } from '@angular/common';
import { RutValidator } from 'ng9-rut';
import { PropiedadService } from 'src/app/services/propiedad.service';
import { PerfilComponent } from '../perfil/perfil.component';
import * as FormActions from '../../reducers/actions/forms.actions';
import { Store } from '@ngrx/store';
import { GLOBAL } from 'src/app/services/global';
import { ClaveUnicaService } from 'src/app/services/clave_unica.service';

interface AppState {
  form: Form;
}

declare const swal: any;
@Injectable()
@Component({
  selector: 'app-solicitud-vivienda-x-num',
  templateUrl: './solicitud-vivienda-x-num.component.html',
  styleUrls: ['./solicitud-vivienda-x-num.component.css'],
  providers: [UserService, PropiedadService]
})
export class SolicitudViviendaXNumComponent {
  @ViewChild('ingresarInfo') ingresarInfo: TemplateRef<any>;


  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  thirdFormGroup: FormGroup;
  info_rut
  dialogConfig
  continuar = false


  //calculo valores certificados
  valores_cert
  valores_cert_noformat
  valor_total_cert = 0
  mostrar_total

  //forms
  public rut = new FormControl('');
  public correo = new FormControl('');
  public nombre = new FormControl('');
  public telefono = new FormControl('');
  public url_fracaso = new FormControl('');
  public url_exito = new FormControl('')

  //direcciones agregadas
  lista_dir = new BehaviorSubject([])
  dirs = []
  identity
  token

  //banderas
  mostrar_solicitud = false
  primerPaso = false
  segundoPaso = false
  tercerPaso = false
  primerPaso_mod = false
  modificando = false
  rut_encontrado = false
  valores_cert_recibidos = false
  cert_seleccionado = false
  folio
  rutcarro
  lista_cert_seleccionados = []
  filteredOptions
  emailValido = false
  link = GLOBAL.webUrl
  nombreLink = GLOBAL.web
  busqueda = true
  infoNumx
  pasoUno = true

  public regexNum = new RegExp(/^[0-9]+$/);
  public regexCel = new RegExp(/^9[0-9]{8}$/i);


  arrayItems: {
    nombre: string;
    aup: boolean;
    cip: boolean;
    num: boolean;
  }[];

  certificados = [{
    cert: "cet",
    nombre_completo: "Constancia de Expediente en Trámite",
    value: "valor_cet",
    state: false
  }]


  constructor(
    private dialog: MatDialog,
    private _prop: PropiedadService,
    private _formBuilder: FormBuilder,
    private _userService: UserService,
    private _snackBar: MatSnackBar,
    private spinner: NgxSpinnerService,
    private _changeDetector: ChangeDetectorRef,
    public rutValidator: RutValidator,
    private _router: Router,
    private store: Store<AppState>,
    private claveUnicaService: ClaveUnicaService) {


    this._userService.get_valores_cert().subscribe(
      response => {
        console.log("solicitud vivienda x response",response)

        this.valores_cert = {
          valor_cet: formatNumber(Math.round(0.1 * response.valores.utm), 'cl'),

        }
        this.valores_cert_noformat = {
          valor_cet: Math.round(0.1 * response.valores.utm),
        }

        console.log(this.valores_cert)
        console.log(this.valores_cert_noformat)

        this.valores_cert_recibidos = true
        this.dialog.closeAll()
        this.spinner.hide()
      }, error => {
        console.log(error)
      }

    )


    this.rut = new FormControl("", Validators.required)

    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.disableClose = true;
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
  }

  ngOnInit() {



    this.arrayItems = [];

    this.firstFormGroup = this._formBuilder.group({
      numX: ['', [Validators.required]],
      rut: ['', [Validators.required, this.rutValidator, Validators.minLength(8)]],
      mod_solicitante: this._formBuilder.group({
        nombre: ['', [Validators.required]],
        apellido_p: [''],
        apellido_m: [''],
        calle: ['', [Validators.required]],
        num: ['', [Validators.required]],
        complemento: [''],
        telefono: [''],
        cel: ['', [Validators.required, Validators.pattern(this.regexCel)]],
        ciudad: [''],
        comuna: [''],
        email: ['', [Validators.required, Validators.email]]
      })
    });

    window.scrollTo(0, 0);
    this.spinner.show()



  }


  solicitar_Certificados() {
    this.mostrar_solicitud = true
    console.log("solicitar certificados")
  }

  cerrar_vista() {
    this.pasoUno = true
    this.mostrar_solicitud = false;
    this.firstFormGroup.reset();
    this.secondFormGroup.reset();
    this.modificando = false
    this.primerPaso = false;
    this.rut.reset();
    this._router.navigate([`/inicio`]);
  }

  buscar_info_sol() {

    console.log("this.firstFormGroup.controls", this.firstFormGroup.controls)
    window.scrollTo(0, 0);
    this.spinner.show()

    var rutSinPuntos = this.firstFormGroup.controls.rut.value
    if (this.firstFormGroup.controls.rut.value.toString().includes(".")) {
      rutSinPuntos = this.firstFormGroup.controls.rut.value.toString().replace(".", "")
      if (rutSinPuntos.includes(".")) {
        rutSinPuntos = rutSinPuntos.replace(".", "")
      }
      console.log("entre en el if de los puntos", rutSinPuntos)
    }
    console.log("RUT", this.firstFormGroup.controls.rut.value);

    this.continuar = false
    this._userService.traerInfo_rutEdificacion(rutSinPuntos).subscribe(
      response => {
        this.rut_encontrado = false
        if (response) {
          this.pasoUno = false
          this.info_rut = response

          this.firstFormGroup.controls.mod_solicitante.setValue({
            nombre: this.info_rut.nombre ? (this.info_rut.nombre).toString().trim() : "",
            apellido_p: this.info_rut.apellido_p ? (this.info_rut.apellido_p).toString().trim() : "",
            apellido_m: this.info_rut.apellido_m ? (this.info_rut.apellido_m).toString().trim() : "",
            calle: this.info_rut.calle ? (this.info_rut.calle).toString().trim() : "",
            num: this.info_rut.numero ? (this.info_rut.numero).toString().trim() : "",
            complemento: this.info_rut.complemento ? (this.info_rut.complemento).toString().trim() : "",
            telefono: this.info_rut.telefono ? (this.info_rut.telefono).toString().trim() : "",
            cel: this.info_rut.celular ? (this.info_rut.celular).toString().trim() : "",
            ciudad: this.info_rut.ciudad ? (this.info_rut.ciudad).toString().trim() : "",
            comuna: this.info_rut.comuna ? (this.info_rut.comuna).toString().trim() : "",
            email: this.info_rut.email ? (this.info_rut.email).toString().trim() : ""
          })

          console.log("infooo rut", this.info_rut)
          this.emailValido = this.info_rut.emailValido
          console.log(this.info_rut)
          console.log(this.info_rut.email == '')
          console.log(this.info_rut.email.length > 0)
          var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (re.test(String(this.info_rut.email).toLowerCase())) {

            this.continuar = true
          }

          this.spinner.hide()
          this.primerPaso = true
          this.rut_encontrado = true
          this._changeDetector.detectChanges()
        }
      }, error => {

        this.modificando = true
        this.rut_encontrado = false
        this.spinner.hide()
      }
    )
  }

  mod_inforut() {
    this.firstFormGroup.controls.mod_solicitante.setValue({
      nombre: this.info_rut.nombre ? (this.info_rut.nombre).toString().trim() : "",
      apellido_p: this.info_rut.apellido_p ? (this.info_rut.apellido_p).toString().trim() : "",
      apellido_m: this.info_rut.apellido_m ? (this.info_rut.apellido_m).toString().trim() : "",
      calle: this.info_rut.calle ? (this.info_rut.calle).toString().trim() : "",
      num: this.info_rut.numero ? (this.info_rut.numero).toString().trim() : "",
      complemento: this.info_rut.complemento ? (this.info_rut.complemento).toString().trim() : "",
      telefono: this.info_rut.telefono ? (this.info_rut.telefono).toString().trim() : "",
      cel: this.info_rut.celular ? (this.info_rut.celular).toString().trim() : "",
      ciudad: this.info_rut.ciudad ? (this.info_rut.ciudad).toString().trim() : "",
      comuna: this.info_rut.comuna ? (this.info_rut.comuna).toString().trim() : "",
      email: this.info_rut.email ? (this.info_rut.email).toString().trim() : ""
    })
    this.primerPaso_mod = true
    this.primerPaso = false
    this.modificando = true

  }

  guarda_mod() {
    window.scrollTo(0, 0);
    this.spinner.show()
    this._userService.modInfo_rutEdificacion(this.info_rut.rut, this.firstFormGroup.controls.mod_solicitante.value).subscribe(
      response => {
        console.log(response)
        this.pasoUno = true
        this.modificando = false

        swal({
          type: 'success',
          title: 'Guardado!',
          text: response.message,
          confirmButtonColor: '#3F51B5',
          confirmButtonText: 'Aceptar',
          timer: 3500
        }).then(() => {
        }, (dismiss) => {
          if (dismiss === 'timer') {
          }
        });
        this.spinner.hide()
      }, error => {
        this.spinner.hide()
        console.log(error)
        swal({
          type: 'error',
          title: 'Ha ocurrido un error!',
          text: error._body,
          confirmButtonColor: '#3F51B5',
          confirmButtonText: 'Aceptar',
          timer: 3500
        }).then(() => {
        }, (dismiss) => {
          if (dismiss === 'timer') {
          }
        });
      }
    )
  }

  registro_sol() {

    var rutSinPuntos = this.firstFormGroup.controls.rut.value
    if (this.firstFormGroup.controls.rut.value.toString().includes(".")) {
      rutSinPuntos = this.firstFormGroup.controls.rut.value.toString().replace(".", "")
      if (rutSinPuntos.includes(".")) {
        rutSinPuntos = rutSinPuntos.replace(".", "")
      }
      console.log("entre en el if de los puntos", rutSinPuntos)
    }

    var userinfo = {
      rut: rutSinPuntos,
      nombre: this.firstFormGroup.controls.mod_solicitante.value.nombre,
      app: this.firstFormGroup.controls.mod_solicitante.value.apellido_p,
      apm: this.firstFormGroup.controls.mod_solicitante.value.apellido_m,
      dir: this.firstFormGroup.controls.mod_solicitante.value.calle,
      num: this.firstFormGroup.controls.mod_solicitante.value.num,
      dircom: this.firstFormGroup.controls.mod_solicitante.value.complemento,
      telefono: this.firstFormGroup.controls.mod_solicitante.value.telefono,
      celular: this.firstFormGroup.controls.mod_solicitante.value.cel,
      ciudad: this.firstFormGroup.controls.mod_solicitante.value.ciudad,
      comuna: this.firstFormGroup.controls.mod_solicitante.value.comuna,
      email: this.firstFormGroup.controls.mod_solicitante.value.email,
    }

    console.log(userinfo)
    this._userService.saveInfo_rutEdificacion(userinfo).subscribe(response => {
      console.log(response)
      swal({
        type: 'success',
        title: 'Registrado!',
        text: response.message,
        confirmButtonColor: '#3F51B5',
        confirmButtonText: 'Aceptar',
        timer: 3500
      }).then(() => {
      }, (dismiss) => {
        if (dismiss === 'timer') {
        }
      });
      this.buscar_info_sol()
      this.modificando = false
    }, error => {
      console.log(error)
      swal({
        type: 'error',
        title: 'Ha ocurrido un error!',
        text: error._body,
        confirmButtonColor: '#3F51B5',
        confirmButtonText: 'Aceptar',
        timer: 3500
      }).then(() => {
      }, (dismiss) => {
        if (dismiss === 'timer') {
        }
      });
    })
  }

  cancelar_mod() {

    if (this.rut_encontrado) {
      this.modificando = false
      this.primerPaso_mod = false
      this.primerPaso = true
    } else {
      this.modificando = false
      this.rut_encontrado = false
      this.primerPaso = false
      this.primerPaso_mod = false
    }

  }


  cerrar_dialog() {

    this.dialog.closeAll()
    this.primerPaso = false
    this.segundoPaso = false
    this.tercerPaso = false
    this.info_rut = []
  }

  calcular_total() {
    var valor = 0;
    this.valor_total_cert = 0
    console.log(this.dirs)
    /*   for (let i = 0; i < this.dirs.length; i++) {
        if (this.dirs[i].cet) {
          this.valor_total_cert = this.valor_total_cert + parseInt(this.valores_cert.valor_cet);
        }
      } */
    console.log(this.valores_cert)
    this.mostrar_total = formatNumber(this.valores_cert_noformat.valor_cet, 'cl')
  }

  public numx = ""
  public dire = ""
  public rol = ""
  public fecha = ""
  public nombreProp = ""
  public nombreArq = ""

  muestraInfo() {
    console.log(this.infoNumx)

    if (this.infoNumx.depto == 1) { //edificacion
      this.numx = this.infoNumx.response.fieldData._TEd_NumeroX ? this.infoNumx.response.fieldData._TEd_NumeroX : ""
      this.dire = this.infoNumx.response.fieldData.TEd_Direc_Completa ? this.infoNumx.response.fieldData.TEd_Direc_Completa : ""
      this.rol = this.infoNumx.response.fieldData.TEd_Pro_ROL ? this.infoNumx.response.fieldData.TEd_Pro_ROL : ""
      this.fecha = this.infoNumx.response.fieldData.TEd_FechaCreacion ? this.infoNumx.response.fieldData.TEd_FechaCreacion : ""
      this.nombreProp = this.infoNumx.response.fieldData.TSE_Ing_Per_Propie_Concatena_Nom ? this.infoNumx.response.fieldData.TSE_Ing_Per_Propie_Concatena_Nom : ""
      this.nombreArq = this.infoNumx.response.fieldData.TSE_Ing_Per_Arqui_Concatena_Nom ? this.infoNumx.response.fieldData.TSE_Ing_Per_Arqui_Concatena_Nom : ""
    }
    if (this.infoNumx.depto == 2) { //urbanizacion
      this.numx = this.infoNumx.response.fieldData._TUr_NumeroX ? this.infoNumx.response.fieldData._TUr_NumeroX : ""
      this.dire = this.infoNumx.response.fieldData.TUr_Direc_Completa ? this.infoNumx.response.fieldData.TUr_Direc_Completa : ""
      this.rol = this.infoNumx.response.fieldData.TUr_Pro_ROL ? this.infoNumx.response.fieldData.TUr_Pro_ROL : ""
      this.fecha = this.infoNumx.response.fieldData.TUr_FechaCreacion ? this.infoNumx.response.fieldData.TUr_FechaCreacion : ""
      this.nombreProp = this.infoNumx.response.fieldData.TSE_Ing_Per_Propie_Concatena_Nom ? this.infoNumx.response.fieldData.TSE_Ing_Per_Propie_Concatena_Nom : ""
      this.nombreArq = this.infoNumx.response.fieldData.TSE_Ing_Per_Arq_Concatena_Nom ? this.infoNumx.response.fieldData.TSE_Ing_Per_Arq_Concatena_Nom : ""
    }
    if (this.infoNumx.depto == 3) { //vivienda social
      this.numx = this.infoNumx.response.fieldData._TVS_NumeroX ? this.infoNumx.response.fieldData._TVS_NumeroX : ""
      this.dire = this.infoNumx.response.fieldData.TVS_Direccion_Completa ? this.infoNumx.response.fieldData.TVS_Direccion_Completa : ""
      this.rol = this.infoNumx.response.fieldData.TVS_Pro_Rol ? this.infoNumx.response.fieldData.TVS_Pro_Rol : ""
      this.fecha = this.infoNumx.response.fieldData.TVS_FechaCreacion ? this.infoNumx.response.fieldData.TVS_FechaCreacion : ""
      this.nombreProp = this.infoNumx.response.fieldData.TSE_Ing_Per_Propie_Concatena_Nom ? this.infoNumx.response.fieldData.TSE_Ing_Per_Propie_Concatena_Nom : ""
      this.nombreArq = this.infoNumx.response.fieldData.TSE_Ing_Per_Arqui_Concatena_Nom ? this.infoNumx.response.fieldData.TSE_Ing_Per_Arqui_Concatena_Nom : ""
    }


  }


  ingresoFm() {
    window.scrollTo(0, 0);
    this.spinner.show()
    this._userService.ingresoConstancia(this.info_rut, this.firstFormGroup.controls.numX.value, this.infoNumx, this.mostrar_total).subscribe(resp => {
      console.log(resp)
      let alert = { icon: 'success', text: '', title: '' }

      if (resp.success) {
        this.spinner.hide()
        alert.icon = 'success'
        alert.text = "Mensaje <p>Sr. Contribuyente, para continuar con el proceso</p> " +
          "<p>será notificado a su correo " + this.info_rut.email + "</p>"
        alert.title = 'Informacion ingresada'

      } else {
        this.spinner.hide()
        alert.icon = 'error'
        alert.text = '<p><strong>' + resp.message + '<strong></p>'
        alert.title = 'No se puede continuar.'

      }

      swal({
        icon: alert.icon,
        title: alert.title,
        text: alert.text,
        showConfirmButton: true,
        confirmButtonText: 'Aceptar',
        allowOutsideClick: false,
        onClose: () => {
          this._router.navigate([`/inicio`]);
        }
      }).then(
        () => {
          window.scrollTo(0, document.body.scrollHeight);
        }
      );

    }, error => {
      console.log(error)
      swal({
        type: 'warning',
        title: 'Ha ocurrido un problema!',
        text: error._body,
        confirmButtonColor: '#3F51B5',
        confirmButtonText: 'Aceptar',
        timer: 4000,
        onClose: () => {
          this._router.navigate([`/inicio`]);
        }
      }).then(() => {
      }, (dismiss) => {
        if (dismiss === 'timer') {
        }
      });
    })

  }



  toLobby() {

    this._router.navigateByUrl('/')

    this.dialog.closeAll();
  }


  closeTab() {
    window.close();
  }

  async logout() {
    this.store.dispatch(new FormActions.FormUpdate('0', ''))
    sessionStorage.removeItem("identity-domCloud");
    sessionStorage.removeItem("token-domCloud");
    this._router.navigate(['/inicio']);
    const response = await this.claveUnicaService.logoutClaveUnica()
    console.log('Deslogeo exitoso:', response);

    this._snackBar.open("Se ha cerrado sesión", "Cerrar", {
      duration: 3000,
    });
  }

  openPerfil() {
    this.dialog.open(PerfilComponent)
  }

  buscarEstado() {
    window.scrollTo(0, 0);
    this.spinner.show()
    console.log(this.firstFormGroup.controls.numX.value)
    console.log("RUT", this.firstFormGroup.controls.rut.value);
  

    var solicitante = { rut: this.firstFormGroup.controls.rut.value }


    this._userService.get_status_numx(solicitante, this.firstFormGroup.controls.numX.value).subscribe(
      response => {
        console.log(response)
        let alert = { icon: 'success', text: '', title: '' }

        if (response.success) {
          this.dialog.closeAll()
          this.infoNumx = response
          this.buscar_info_sol()


        } else {
          this.spinner.hide()
          alert.icon = 'error'
          alert.text = '<p><strong>' + response.message + '<strong></p>'
          alert.title = 'No se puede continuar.'
          swal({
            icon: alert.icon,
            title: alert.title,
            text: alert.text,
            showConfirmButton: true,
            confirmButtonText: 'Aceptar',
            allowOutsideClick: false
          }).then(
            () => {
              window.scrollTo(0, document.body.scrollHeight);
            }
          );
        }

      }, error => {
        console.log(error)
      }

    )


  }




  checkRut(rut) {
    var cuerpo
    var dv
    var suma
    var multiplo
    var i
    var index
    var dvEsperado

    // Despejar Puntos
    var valor = rut.replace('.', '');
    // Despejar Guión
    valor = valor.replace('-', '');

    // Aislar Cuerpo y Dígito Verificador
    cuerpo = valor.slice(0, -1);
    dv = valor.slice(-1).toUpperCase();

    // Formatear RUN
    rut = cuerpo + '-' + dv

    // Si no cumple con el mínimo ej. (n.nnn.nnn)
    if (cuerpo.length < 7) { rut.setCustomValidity("RUT Incompleto"); return false; }

    // Calcular Dígito Verificador
    suma = 0;
    multiplo = 2;

    // Para cada dígito del Cuerpo
    for (i = 1; i <= cuerpo.length; i++) {

      // Obtener su Producto con el Múltiplo Correspondiente
      index = multiplo * valor.charAt(cuerpo.length - i);

      // Sumar al Contador General
      suma = suma + index;

      // Consolidar Múltiplo dentro del rango [2,7]
      if (multiplo < 7) { multiplo = multiplo + 1; } else { multiplo = 2; }

    }

    // Calcular Dígito Verificador en base al Módulo 11
    dvEsperado = 11 - (suma % 11);

    // Casos Especiales (0 y K)
    dv = (dv == 'K') ? 10 : dv;
    dv = (dv == 0) ? 11 : dv;

    // Validar que el Cuerpo coincide con su Dígito Verificador
    if (dvEsperado != dv) { rut.setCustomValidity("RUT Inválido"); return false; }

    // Si todo sale bien, eliminar errores (decretar que es válido)
    rut.setCustomValidity('');
  }

}
